import { ICommonResponse } from '../core/api/http-methods/common-response.type';
import { apiClient } from './client';

export interface UserPinLimit {
  currency_code: string;
  pin_limit: number;
}

export interface UpsertPinLimitPayload {
  currency_code: string;
  pin_limit: number;
  pin: string;
}

export const getUserPinLimits = async (): Promise<UserPinLimit[]> => {
  const response = await apiClient.get<ICommonResponse<UserPinLimit[]>>('/user-pin-limits');
  return response.data.success ? response.data.data : [];
};

export const upsertUserPinLimit = async (payload: UpsertPinLimitPayload): Promise<void> => {
  await apiClient.put('/user-pin-limits', payload);
};
